export { default as LoyaltyCtaBar } from './loyalty-cta-bar';
